import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { OrganizationStateService } from '../../../shared/organization-state.service';
import { AppProfile } from '../../../shared/app-profile/app-profile';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AddSubOrganizationService {
  constructor(
    private readonly http: HttpClient, 
    private readonly authSvc: AuthService, 
    private readonly orgState: OrganizationStateService,
    private readonly appProfile: AppProfile
  ) {}

  /**
   * Returns an observable with the parent org id and name, using the correct permission-aware logic.
   */
  getParentOrgInfo() {
    const permissions = this.authSvc.userPermissions || [];
    if (permissions.includes('AccessProductSupportConsole')) {
      // Wait for orgState to emit a value
      return this.orgState.orgResponse$.pipe(
        map(org => ({
          parentOrgId: org?.orgId || '',
          parentOrgName: org?.name || ''
        }))
      );
    } else {
      // Use AuthService for top org id
      return new Observable<{ parentOrgId: string; parentOrgName: string }>(observer => {
        observer.next({
          parentOrgId: this.authSvc.userTopOrgId || '',
          parentOrgName: '' // Optionally fetch name if available
        });
        observer.complete();
      });
    }
  }

  createSubOrg(payload: any, token: string): Observable<any> {
    if (token) {
      const headers = this.authSvc.getCommonHeaders(token, '1.0.0');
      return this.http.post(`${this.appProfile.epUs}/organization-ms/organization/sub-orgs`, payload, { headers });
    }
  }
}
